import { render, staticRenderFns } from "./formDetail.vue?vue&type=template&id=5dd236e4&scoped=true"
import script from "./formDetail.vue?vue&type=script&lang=js"
export * from "./formDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd236e4",
  null
  
)

export default component.exports